export const autoAddressTransformer = (data: any) => {
    const { response } = data;
    if (data.status == 'success' && response) {
      return {
        success: true,
        pincodeMessage: response.pincode_message,
        isCodAvailable: !!response.cod_availabe,
        codMessage: response.cod_message,
        isFastDeliveryAvailable: !!response.fast_delivery_availabe,
        fastDeliveryMessage: response.fast_delivery_message,
        showPincodeCheck: response.show_pincode_check,
        deliveryText: response.delivery_text,
        ExtraMessage1: response.ExtraMessage1,
        ExtraMessage2: response.ExtraMessage2,
        city: response.city,
        state: response.state,
        country: response.country,
        deliveryTime: response.delivery_time,
      };
    } else {
      return {
        success: false,
        message: data.message,
      };
    }
};

export const postCodeTransformer = (data:any) => {

  const { response } = data;
  if (data.status === 'success' && response) {
    return {
      success:true,
      city: response.city,
      state: response.regionName,
      regionCode: response.regionCode,
      regionName: response.regionName,
      country: response.country,
      countryName: response.countryName,
      countryFullName: response.countryFullName,
      regionId:response.state,
      error: 0,
    };
  } else {
    return {
      success: false,
      message: data.message,
    };
  }
};

export const addressServiceabilityForFashion = (response: any={}) => {
  const { data } = response;
  if(response.success === true) {
    /**
     * Have to Handle the non serviceable pincode
     * should return success as false to show error in case of non serviceable pincode
     */
    if(!data?.pincodeDetails?.serviceable){
      return {
        success: false,
        message: data?.pincodeDetails?.message, // check if we get the message for non serviceable pincode
      };
    }
    return {
      success: true,
       // have to verify the non serviceable pincode
      city: data?.pincodeDetails?.city,
      state: data?.pincodeDetails?.state,
      country: data?.pincodeDetails?.countryCode,
      countryName: data?.pincodeDetails?.country,
      codEnabled: data?.pincodeDetails?.codEnabled,
      prepaidEnabled: data?.pincodeDetails?.prepaidEnabled,
      serviceable: data?.pincodeDetails?.serviceable,
      inventory: data?.businessModelServiceabilityDetails?.inventory,
      marketplace: data?.businessModelServiceabilityDetails?.marketplace,
      ngs: data?.businessModelServiceabilityDetails?.ngs,
    };
  }else{
    return {
      success: false,
      message: response.message,
    };
  }
}
